var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileSideIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  fill: "none",
  viewBox: "0 0 19 19",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 7.916,
  r: 2.375,
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 7.125,
  stroke: "#49475A",
  strokeWidth: 1.3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M14.25 14.809c-.28-.842-.898-1.586-1.756-2.116-.86-.53-1.912-.818-2.994-.818s-2.135.287-2.994.818c-.858.53-1.476 1.274-1.756 2.116"
})));
export { SvgProfileSideIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/profile-side-icon.svg";